import { render, staticRenderFns } from "./AnalisePedidosXAbastecimento.vue?vue&type=template&id=71a71e66"
import script from "./AnalisePedidosXAbastecimento.vue?vue&type=script&lang=js"
export * from "./AnalisePedidosXAbastecimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports